export default "__VITE_ASSET__BhHolJKD__"